import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=5e4830d8&"
import script from "./InfoMessage.vue?vue&type=script&lang=ts&"
export * from "./InfoMessage.vue?vue&type=script&lang=ts&"
import style0 from "./InfoMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports